import { render } from "./InternetNetwork.vue?vue&type=template&id=3a8e6fe1&scoped=true"
import script from "./InternetNetwork.vue?vue&type=script&lang=js"
export * from "./InternetNetwork.vue?vue&type=script&lang=js"

import "./InternetNetwork.vue?vue&type=style&index=0&id=3a8e6fe1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8e6fe1"]])

export default __exports__